const uiElementMeasures = {
    inputElementsInRoomPickerMinHeight: "42px",
    inputElementsInRoomPickerMinHeightLessTwo: "40px",
    marginBetweenElementsInColumn: "16px",
    defaultBorderRadius: "10px",


}
export default uiElementMeasures